module.exports = __webpack_public_path__ + "static/media/ad.5de660df.png";